import { ALTERAR_RESERVA_ITINERARIO } from '../types'

export default function alterarReservaItinerario (reserva) {
  return {
    type: ALTERAR_RESERVA_ITINERARIO,
    payload: reserva
  }
}